import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Van = createSvgIcon(
  <path d="M0 3h17.125c.757 0 1.44.455 1.73 1.154l1.511 3.625 2.52 1.12A1.872 1.872 0 0 1 24 10.612v8.138h-3.192a3.377 3.377 0 0 1-6.366 0H9.558a3.376 3.376 0 0 1-6.366 0H0V3Zm21.75 13.5v-5.25h-10.5v-6h-9V16.5h.942a3.376 3.376 0 0 1 6.366 0h4.884a3.376 3.376 0 0 1 6.366 0h.942ZM18.437 9l-1.562-3.75H13.5V9h4.938Z" />,
  'Van'
);

export { Van };